<template>
    <div>
        <b-modal id="bv-modal-session-expired" centered hide-footer :no-close-on-backdrop="true" @close="resetCart()">
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
                <span>
                    {{ getTranslation('front', 'session_expired_modal_title')}}
                </span>
            </template>
            <div class="d-block text-center">
                <br>
                <p>
                    {{ modalOptions.message }}
                </p>
                <br>
            </div>
            <div class="text-center">
                <b-button class="mt-3 mx-auto"  @click="redirectTo('/', true, modalOptions.action)">
                    {{ getTranslation('front', 'session_expired_modal_button_new_order') }}
                </b-button>
                <b-button class="mt-3 mx-auto"  @click="redirectTo(modalOptions.buttonLink, true, modalOptions.action)">
                    {{ modalOptions.buttonText }}
                </b-button>
            </div>
        </b-modal>

    </div>
</template>
<script>
    export default {
        methods: {
            redirectTo(url, emptyCart = false, action) {
                if (emptyCart) {
                    this.loggedOutPrepare();
                    this.$store.commit('changeLoggedInUser', this.loggedInUser);
                    this.resetCart();
                    let payload = {'dealerId': this.dealerImpersonated};
                    this.$store.commit('setDealer', payload);
                }
                location.href = this.baseUrl + url;
            },
            resetCart() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('changeLoggedInUser', this.loggedInUser);

                payload = {'dealerId': this.dealerImpersonated};
                this.$store.commit('setDealer', payload);
                this.$store.commit('emptyHardlocks');
                this.$store.commit('setMustConfirm', 1);
                this.$store.commit('addPromoLease', {});
                this.deleteLeaseProlongData();
            },
            logOutUser() {
                this.resetCart();
                this.$store.commit('changeLoggedInUser', 0);
            },
            deleteLeaseProlongData() {
                let self = this;
                //delete the options
                _.forOwn(this.products, function(p) {
                    if (!self.isTruss4Product(p.id)) {
                        let payload = {product: p.id};
                        self.$store.commit('deleteLeaseProlongConfig', payload);
                        self.$store.commit('updateLeaseOptions', {
                            id: p.id,
                            data: {},
                        });
                    }
                });

                //delete the days
                _.forOwn(this.$store.state.cart.programs, function(p) {
                    //clear the custom days
                    let payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'days'
                    }
                    self.$store.commit('upgradeCartProgram', payload);

                    //clear the perpetual upgrade
                    payload = {
                        id: p.id,
                        upgrade: false,
                        column: 'perpetual_upgrade'
                    }
                    self.$store.commit('upgradeCartProgram', payload);
                });
            },
            justLoggedInPrepare() {
                this.$store.commit('emptyCart', {});
                newCart.init();
                this.initUserType();

                this.initMaintenance();
                //set logged in user in cart, empty lease prolong and single upgrade
                this.$store.commit('changeLoggedInUser', this.loggedInUser);
                this.$store.commit('emptyHardlocks');
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('resetMaintenance', {});

                //setup single upgrade data for cart.

                this.$store.commit('setKanUserInfo', this.kanUserInfo);
                this.$store.commit('setUserInfo', {});
                this.$store.commit('addPromoLease', {});
            },
            justLoggedOutPrepare() {
                this.setSoftwareLanguage();
                this.$store.commit('changeLoggedInUser', 0);
                this.$store.commit('emptyHardlocks');
                //remove all programsLanguages that are not in cart.
                this.$store.commit('emptyLanguages', 0);

                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('setKanUserInfo', {});
                this.$store.commit('setUserInfo', {});
                this.$store.commit('changeUserLevel', 'personal');
                this.$store.commit('changeExistingUserLevel', '');
                this.$store.commit('addPromoLease', {});
            },
            initUserType() {
                let type = this.existingUserType;
                let types = _.find(this.shopUserTypes, function(u) { return u.id === type });
                let upgradeUserLevel = 'personal';

                if (!_.isNil(types)) {
                    upgradeUserLevel = types['type'];
                }
                this.$store.commit('changeUserLevel', upgradeUserLevel);
                this.$store.commit('changeExistingUserLevel', upgradeUserLevel);
            },
            loggedInPrepare() {
                let self = this;
                this.initMaintenance();
                //setup lease prolong data for cart.
                if (!_.isNil(this.leaseProlong)) {
                    _.forOwn(this.leaseProlong, function(pr, key) {
                        if (!_.isUndefined(self.leaseProlong[key].info)) {
                            self.leaseProlong[key].info.forEach(function(l, index) {
                                l.price = self.getProgramPrice(l.id, '', 'lease_local_quantity', key, l.quantity);
                            });
                        }
                        let payload = {
                            product: key,
                            data: self.leaseProlong[key]
                        };
                        if (_.isEmpty(self.$store.state.cart.leaseProlong[key])) {
                            self.$store.commit('initLeaseProlong', payload);
                        }
                        if (self.isTruss4Product(key)) {
                            if (!_.isEmpty(self.$store.state.cart.programs)) {
                                _.forOwn(self.$store.state.cart.programs, function (pr) {
                                    if (pr.product == key) {
                                        self.$store.commit('removeFromCart', {item: pr});
                                    }
                                });
                            }
                        }
                    });
                }

                if (!_.isNil(this.singleUpgrade)) {
                    _.forOwn(this.singleUpgrade, function(pr, key) {
                        let payload = {
                            product: key,
                            data: self.singleUpgrade[key]
                        };
                        if (_.isEmpty(self.$store.state.cart.singleUpgrade[key])) {
                            self.$store.commit('initSingleUpgrade', payload);
                        }

                    });
                }

            },
            loggedOutPrepare() {
                // this.$store.commit('setKanUserInfo', {});
            },
            clearProgramLanguages() {
                this.$store.commit('removeAllProgramLanguages', {});
            },
            setSoftwareLanguage() {
                if (!_.isNil(this.softwareLanguages) && _.isEmpty(this.$store.state.cart.softwareLanguage)) {
                    let self = this;
                    let softwareLanguages = {};
                    _.forOwn(this.softwareLanguages, function(lang, product) {
                        if (self.languages[product]['items'].hasOwnProperty(self.softwareLanguages[product])) {
                            softwareLanguages[product] = self.softwareLanguages[product];
                        } else {
                            softwareLanguages[product] = self.defaultReportLanguage;
                        }
                    });
                    this.$store.commit('setSoftwareLanguages', {languages: softwareLanguages});
                    let payload = {'step': 1};
                    this.$store.commit('setCartStep', payload);
                    this.$store.commit('setMustConfirm', 1);
                }
            },
            initMaintenance() {
                return false;
            },
            setModalData(type) {

                if (type === 'user') {
                    this.modalOptions = {
                        buttonText: this.getTranslation('front', 'session_expired_modal_button_login_user'),
                        buttonLink: '/login',
                        message: this.getTranslation('front', 'session_expired_modal_message_login_user'),
                        action: 'user'
                    }
                } else if (type === 'dealerNewCustomer') {
                    this.modalOptions = {
                        buttonText: this.getTranslation('front', 'session_expired_modal_button_login_dealer'),
                        buttonLink: '/dealer',
                        message: this.getTranslation('front', 'session_expired_modal_message_login_dealer'),
                        action: 'dealer'
                    }
                } else if (type === 'dealerExistingCustomer') {
                    this.modalOptions = {
                        buttonText: this.getTranslation('front', 'session_expired_modal_button_login_dealer_impersonating'),
                        buttonLink: '/dealer',
                        message: this.getTranslation('front', 'session_expired_modal_message_login_dealer_impersonating'),
                        action: 'dealer'
                    }
                }
            },
            getImpersonatedDealer() {
                let cartDealer = 0;
                if (!_.isNil(this.$store.state.cart.dealerId)) {
                    cartDealer = this.$store.state.cart.dealerId;
                }
                return cartDealer;
            },
            checkDealerImpersonated() {
                let cartDealer = this.getImpersonatedDealer();
                this.dealerImpersonated = _.toNumber(this.dealerImpersonated);

                let urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('resetStep')) {
                    this.resetCart();
                    return 1;
                }

                if (!this.dealerImpersonated) {
                    //dealer session expired. show popup message
                    if (cartDealer > 0) {
                        if (this.cartStorage.loggedInUser) {
                            this.setModalData('dealerExistingCustomer');
                        } else {
                            this.setModalData('dealerNewCustomer');
                        }
                        this.$bvModal.show('bv-modal-session-expired');
                        this.$store.commit('changeUserLevel', 'personal');
                    }
                }

                if (this.dealerImpersonated && this.cartStorage.loggedInUser && this.loggedInUser == 0) {
                    this.setModalData('dealerExistingCustomer');
                    this.$bvModal.show('bv-modal-session-expired');
                    this.$store.commit('changeUserLevel', 'personal');
                }

                if (cartDealer != this.dealerImpersonated && this.dealerImpersonated) {
                    let payload = {'dealerId': this.dealerImpersonated};
                    this.$store.commit('setDealer', payload);
                }
            },

        },
        mounted () {
            this.checkDealerImpersonated();
            if (this.$store.state.cart.loggedInUser && this.getImpersonatedDealer() == 0 && this.loggedInUser == 0) {
                this.setModalData('user');
                this.$bvModal.show('bv-modal-session-expired');
                this.$store.commit('changeUserLevel', 'personal');
            }
            if (this.$store.state.cart.existingUserLevel && this.loggedInUser == 0) {
                this.$store.commit('changeExistingUserLevel', '');
            }

        },
        beforeMount() {
            if (this.justLoggedOut) {
                this.resetCart();
                this.justLoggedOutPrepare();
            }
            if (this.finishedOrder) {

                this.$store.commit('emptyCart', {});
                newCart.init();
                this.justLoggedInPrepare();
            }

            if (this.loggedInUser != 0) {
                this.isLoggedIn = 1;
                if (this.cartStorage.loggedInUser == 0) {
                    this.justLoggedInPrepare();
                }
                this.loggedInPrepare();
            }

            if (this.justLoggedOut) {
                this.clearProgramLanguages();
            }
            if (this.mustConfirm != -1) {
                this.$store.commit('setMustConfirm', this.mustConfirm);
            }
            if (this.resetCartStep) {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
            }

        },
        data: function() {
            return {
                justLoggedOut: window.justLoggedOut,
                cartStorage: this.$store.state.cart,
                loggedInUser: window.loggedInUser,
                isLoggedIn: 0,
                singleUpgrade: JSON.parse(window.singleUpgrade),
                leaseProlong: JSON.parse(window.leaseProlong),
                apiPrograms: JSON.parse(window.apiPrograms),
                kanUserInfo: window.kanUserInfo ?? {},
                finishedOrder: window.finishedOrder ?? 0,
                mustConfirm: window.mustConfirm,
                softwareLanguages: window.softwareLanguage ?? {},
                languages: window.jsonLanguages ?? {},
                licences: window.licences,
                products: window.jsonProducts,
                currencyList: window.currencyList,
                resetCartStep: window.resetCartStep,
                dealerImpersonated: window.dealerImpersonated,
                baseUrl: window.baseUrl,
                modalOptions: {
                    buttonText: '',
                    buttonLink: '',
                    message: '',
                    action: ''
                },
                existingUserType: window.existingUserType,
                shopUserTypes: window.shopUserTypes,
            }
        },

    }
</script>

<style>


</style>
